import { ErrorTypes } from '../../../typings'
import { ERROR_DISPLAY_TYPES, HOME_PATH } from '../../constants'
import { clearHandledError } from '../../store/slices/handledErrorSlice'
import logger from '../logger'
import { goToCIP } from '../redirect/cip'
import { goToStepUpAuth } from '../redirect/step-up'
import { reloadHome } from '../redirect/auth'
import { resumeCreate, resumeUpdate } from './actions/resume'

const { IN_PAGE, FULLSCREEN, REDIRECT, FULL_SHEET, DISPATCH } =
  ERROR_DISPLAY_TYPES
const GENERIC_ERROR_TITLE = 'error.generic'

const GENERIC_IN_PAGE_ERROR = {
  type: IN_PAGE,
  title: GENERIC_ERROR_TITLE,
}

const GENERIC_FULLSCREEN_ACTION = {
  title: 'app.ok',
  href: HOME_PATH,
}

const errorByCode: {
  [key: string]: ErrorTypes
} = {
  AUTH_REQUIRED: {
    type: REDIRECT,
    title: null,
    redirect: reloadHome,
  },
  COERCING_PARSE_VALUE: GENERIC_IN_PAGE_ERROR,
  COMPLIANCE_DECLINE: {
    type: FULL_SHEET,
    title: 'error.complianceDecline',
    description: 'error.complianceDeclineDescription',
    action: GENERIC_FULLSCREEN_ACTION,
  },
  EXAMPLE_ERROR_WITH_REACH_ROUTER_NAVIGATE: {
    type: FULLSCREEN,
    title: 'error.message1',
    description: 'error.description1',
    action: {
      title: 'app.ok',
      navigate: HOME_PATH, // not yet implemented in FullScreenError.tsx
    },
  },
  EXAMPLE_ERROR_WITH_DISPATCHED_ACTION: {
    type: FULLSCREEN,
    title: 'error.errorMessage2',
    description: 'error.errorMessageDescription2',
    action: {
      title: 'app.ok',
      dispatch: clearHandledError,
    },
  },
  FETCH_ERROR: GENERIC_IN_PAGE_ERROR,
  INVALID_TIME_RANGE: {
    type: IN_PAGE,
    title: 'error.fundRaiserTimeRangeInvalid',
  },
  MAXIMUM_ACTIVE_MONEY_POOLS_LIMIT_EXCEEDED: {
    type: IN_PAGE,
    title: 'groupsList.error.maxGroups',
  },
  MAXIMUM_POOLS_LIMIT_REACHED: {
    type: IN_PAGE,
    title: 'error.maximumPoolsLimitReached',
  },
  MAXIMUM_POOLS_HARD_LIMIT_REACHED: {
    type: IN_PAGE,
    title: 'error.maximumLifeTimePoolsReached',
  },
  MEDIA_BAD_USER_DATA: GENERIC_IN_PAGE_ERROR,
  MEDIA_SERVICE_ERROR: GENERIC_IN_PAGE_ERROR,
  MEDIA_TYPE_NOT_SUPPORTED: {
    type: IN_PAGE,
    title: 'error.mediaTypeNotSupported',
  },
  MONEY_POOL_CREATION_DENIED_FOR_INACTIVE_PRODUCT_FEATURE: {
    type: REDIRECT,
    title: null,
    redirect: goToCIP,
  },
  NON_NULLABLE_VALUE_COERCED_AS_NULL: GENERIC_IN_PAGE_ERROR,
  RATE_LIMIT_REACHED: {
    type: FULLSCREEN,
    title: GENERIC_ERROR_TITLE,
    action: GENERIC_FULLSCREEN_ACTION,
  },
  RESOURCE_NOT_FOUND: {
    type: FULLSCREEN,
    title: 'error.cannotContribute',
    description: 'error.payPalDoesNotSupportContributions',
    action: GENERIC_FULLSCREEN_ACTION,
  },
  RISK_DECLINE: {
    type: IN_PAGE,
    title: 'error.generic',
  },
  STEP_UP_AUTHENTICATION_REQUIRED: {
    type: REDIRECT,
    title: null,
    redirect: goToStepUpAuth,
  },
  STEP_UP_RESUME_CREATE: {
    type: DISPATCH,
    title: null,
    getAction: resumeCreate,
  },
  STEP_UP_RESUME_UPDATE: {
    type: DISPATCH,
    title: null,
    getAction: resumeUpdate,
  },
  SERIALIZATION_ERROR: {
    type: FULLSCREEN,
    title: GENERIC_ERROR_TITLE,
    action: GENERIC_FULLSCREEN_ACTION,
  },
  UNABLE_CREATE: {
    type: IN_PAGE,
    title: 'error.unableToCreate',
  },
  UNKNOWN: GENERIC_IN_PAGE_ERROR,
  UNKNOWN_CRITICAL: {
    type: FULLSCREEN,
    title: GENERIC_ERROR_TITLE,
    action: GENERIC_FULLSCREEN_ACTION,
  },
}

export const HANDLED_ERROR_CODES = Object.keys(errorByCode).reduce<
  Record<string, string>
>((result, key) => {
  result[key] = key
  return result
}, {})

export const lookupErrorMessageByErrorCode = (code: string) => {
  const resolvedCode = errorByCode[code]
  if (!resolvedCode) {
    // log this error to CAL so that we can report on any error codes that we have not
    // specifically handled.
    logger.warn('CLIENT', {
      message: `Could not resolve error code: [${code}] `,
    })

    /* default needs to be a full page error, because there are scenarios when an error
     *  could occur, and we are not in a Sheet.  IN_PAGE errors currently only work in Sheets. */
    return errorByCode.UNKNOWN_CRITICAL
  }
  return resolvedCode
}
